import React from "react"
import { Link } from "react-router-dom"
import {
    Card,
    CardBody,
   
    Table,
    CardTitle,
  } from "reactstrap"

export  const expandRow = {
    renderer: row => (
      <React.Fragment>
          <Card>
                <CardBody>
                  <CardTitle className="mb-3">Order Summary</CardTitle>

                  <div className="table-responsive">
                    <Table className="table mb-0">
                      <tbody>
                        <tr>
                          <th>Order Images</th>
                          <td>
                              {
                                  row.hasOwnProperty("fileName") ? (<p><Link to={row.uploadfileName}> {row.fileName}</Link></p>) : "" 
                              }
                              {
                                  row.hasOwnProperty("fileName1") ? (<p><Link to={row.uploadfileName1}> {row.fileName1}</Link></p>) : "" 
                              }

                          </td>
                        </tr>
                        <tr>
                          <th>Price </th>
                          <td>{row.price}</td>
                        </tr>
                        <tr>
                          <th>Placement</th>
                          <td>{row.placement}</td>
                        </tr>
                        <tr>
                          <th>Blending</th>
                          <td>{row.blending}</td>
                        </tr>
                        <tr>
                          <th>Heigh</th>
                          <td>{row.height}</td>
                        </tr>
                        <tr>
                          <th>Width</th>
                          <td>{row.width}</td>
                        </tr>
                        <tr>
                          <th>Urgent</th>
                          <td>{row.hasOwnProperty("rush") ? row.rush : ""}</td>
                        </tr>
                        <tr>
                          <th>Format</th>
                          <td>{row.requiredFormat}</td>
                        </tr>
                        <tr>
                          <th>PO</th>
                          <td>{row.po}</td>
                        </tr>
                        <tr>
                          <th>Colors</th>
                          <td>{row.numberOfColors}</td>
                        </tr>
                        <tr>
                          <th>Instractions</th>
                          <td>{row.hasOwnProperty("additionalInstructions") ? row.additionalInstructions : ""}</td>
                        </tr>
                        <tr>
                          <th>Price Status</th>
                          <td>{row.hasOwnProperty("paymentStatus") ? row.paymentStatus == false ? "Reciveable" : "Received" : ""}</td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
      </React.Fragment>
    ),
    showExpandColumn: true,
  }